export { default } from "./DealsDisclaimer";
